import { gql } from '@apollo/client'
import { ORGANIZATION_MODEL } from './modelFields'

export const GET_ORG_TYPES = gql`
  query OrgTypes {
    orgTypes
  }
`

export const ORGANIZATIONS_AUTOCOMPLETE = gql`
  query OrganizationsAutocomplete($query: String!) {
    organizationsAutocomplete(query: $query) {
      ${ORGANIZATION_MODEL}
    }
  }
`

export const CREATE_ORGANIZATION = gql`
  mutation CreateOrganization($organization: OrganizationInput!) {
    createOrganization(organization: $organization) {
      ${ORGANIZATION_MODEL}
    }
  }
`

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization(
    $organizationId: ID!
    $organization: OrganizationInput!
  ) {
    updateOrganization(
      organizationId: $organizationId
      organization: $organization
    ) {
      ${ORGANIZATION_MODEL}
    }
  }
`
